import { jsPDF } from "jspdf";

const SLATE = [15, 23, 42], INDIGO = [79, 70, 229], GREY = [100, 116, 139];
const dt = (v) => (v ? new Date(v).toLocaleString("en-CA", { timeZone: "UTC", hour12: false }) + " UTC" : "—");

export const buildDisputePdf = (ev) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth(), H = doc.internal.pageSize.getHeight(), M = 40;
  let y = 0;
  const room = (n) => { if (y + n > H - 50) { doc.addPage(); y = 50; } };
  const heading = (t) => { room(40); y += 18; doc.setFont("helvetica", "bold"); doc.setFontSize(13); doc.setTextColor(...INDIGO); doc.text(t, M, y); y += 6; doc.setDrawColor(...INDIGO); doc.line(M, y, W - M, y); y += 16; };
  const row = (k, v) => {
    const lines = doc.splitTextToSize(String(v ?? "—"), W - M * 2 - 150);
    room(lines.length * 13 + 4);
    doc.setFont("helvetica", "bold"); doc.setFontSize(9.5); doc.setTextColor(...GREY); doc.text(k, M, y);
    doc.setFont("helvetica", "normal"); doc.setTextColor(...SLATE); doc.text(lines, M + 150, y);
    y += lines.length * 13 + 3;
  };
  doc.setFillColor(...SLATE); doc.rect(0, 0, W, 92, "F");
  doc.setTextColor(255); doc.setFont("helvetica", "bold"); doc.setFontSize(19); doc.text("LexVersant — Payment Dispute Evidence", M, 42);
  doc.setFont("helvetica", "normal"); doc.setFontSize(10);
  doc.text(`lexversant.ca (Canada)  ·  Generated ${dt(ev.generated_at)}  ·  Customer ID ${ev.user_id}`, M, 66);
  y = 110;

  const s = ev.student;
  heading("1. Customer");
  [["Name", s.name], ["Email", s.email], ["Phone", s.phone_number], ["Sign-in method", s.auth_provider], ["Email verified", s.email_verified == null ? "—" : s.email_verified ? "Yes" : "No"],
    ["Account created", dt(s.signed_up_at)], ["Last active", dt(s.last_active_at)], ["Pass status", s.membership_status], ["Pass expires", dt(s.membership_expires_at)],
    ["Account status", s.account_deleted ? (s.deleted_at ? `Deleted by customer on ${dt(s.deleted_at)}` : "Account removed (no snapshot kept)") : "Active"]].forEach(([k, v]) => row(k, v));

  heading("2. Payments and Terms acceptance");
  if (!ev.payments.length) row("Payments", "No checkout sessions on record.");
  ev.payments.forEach((p, i) => {
    room(30); doc.setFont("helvetica", "bold"); doc.setFontSize(10.5); doc.setTextColor(...SLATE); doc.text(`Payment ${i + 1} — ${p.plan}`, M, y); y += 15;
    [["Amount", `$${Number(p.amount || 0).toFixed(2)} ${p.currency}`], ["Status", p.payment_status], ["Checkout started", dt(p.created_at)], ["Paid", dt(p.paid_at)],
      ["Stripe session", p.session_id], ["Payment intent", p.payment_intent], ["Terms accepted", p.terms_accepted ? "Yes — mandatory checkbox ticked before checkout" : "No record"],
      ["Terms version", p.terms_version], ["Accepted at", dt(p.accepted_at)], ["Client IP", p.client_ip], ["Browser", p.user_agent]].forEach(([k, v]) => row(k, v));
    y += 6;
  });

  const a = ev.activity;
  heading("3. Service usage after purchase");
  [["Full tests completed", a.tests_completed], ["Practice questions answered", a.practice_questions_answered], ["Practice sections started", a.practice_sections_started],
    ["AI tutor messages sent", a.tutor_messages], ["Last practice activity", dt(a.last_practice_at)]].forEach(([k, v]) => row(k, v));
  if (a.tests?.length) {
    y += 6; room(20); doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(...SLATE); doc.text("Test history", M, y); y += 14;
    a.tests.forEach((t) => row(dt(t.date).replace(" UTC", ""), `${t.title}  ·  score ${t.overall ?? "—"}${t.pass == null ? "" : t.pass ? " (passed)" : ""}`));
  }

  heading("4. Policy");
  row("Refunds", "All sales are final. Passes are non-refundable once payment is complete, as stated in the Terms and Conditions (lexversant.ca/terms) accepted at checkout.");
  row("Disputes contact", "paymentdispute@lexversant.ca");

  const pages = doc.getNumberOfPages();
  for (let i = 1; i <= pages; i++) { doc.setPage(i); doc.setFontSize(8); doc.setTextColor(...GREY); doc.text(`LexVersant dispute evidence · ${s.email} · page ${i} of ${pages}`, M, H - 24); }
  return doc;
};

export const disputePdfName = (ev) => `lexversant_dispute_${(ev.student.email || ev.user_id).replace(/[^a-z0-9]+/gi, "_")}_${ev.generated_at.slice(0, 10)}.pdf`;
export const downloadDisputePdf = (ev) => buildDisputePdf(ev).save(disputePdfName(ev));
